import React from 'react';
import FaiBox from "../../../../MuiComponents/FaiBox";
import DataTable from "../../../../components/DataTable";

interface ProductListProps {
    data: any;

    [key: string]: any;
}

function OrderList<ProductListProps>(props: { data: any; }) {
    const {data} = props;
    return (
        <>
            <FaiBox>
                <DataTable
                    table={data}
                    pagination={{
                        variant: "contained",
                        color: "primary",
                    }}/>
            </FaiBox>
        </>
    );
}

export default OrderList;
